export const homeFor = (role) => (role === "contractor" ? "/contractor" : role === "sales" ? "/sales" : "/");
